"use strict";
var ACC;
ACC.common = {
    isBannerExpanded: false,
    currentPath: window.location.pathname,
    processingMessage: $("<img src='" + ACC.config.commonResourcePath + "/images/spinner.gif'/>"),
    productMultiSix: false,
    localCartJsonKey: 'localCartJsonData',
    blockFormAndShowProcessingMessage: function (submitButton)
    {
        var form = submitButton.parents('form:first');
        form.block({ message: ACC.common.processingMessage });
    },

    refreshScreenReaderBuffer: function ()
    {
        // changes a value in a hidden form field in order
        // to trigger a buffer update in a screen reader
        $('#accesibility_refreshScreenReaderBufferField').attr('value', new Date().getTime());
    },

    productCheck : function() {
        if (window.location.href.indexOf('/p/') != -1) {

            if ($('#isFlashProduct').val() === 'true') {
                if (ACC.common.getCookiebyName('customerName') === null) {
                    window.location.href = $('#flashEventURL').val();
                }
            }
        }
    },

    getParameterByVideoClick: function(cssSelector) {
    var componentId = $(cssSelector).data("componentid");
            var viewNumber = $(cssSelector).data("viewnumber");
			var dataUrl = $(cssSelector).data("url");
			var dataName = $(cssSelector).data("name");
            if (typeof componentId !== 'undefined' && typeof viewNumber !== 'undefined') {
				try {
					ACC.gtm.trackPromotionEditorialVideoClickGtmEvent(componentId, viewNumber, dataUrl, dataName);
				} catch (error) {
					console.error("Error in trackPromotionClickGtmEvent: ", error);
				}
			}
        },
    //get any document.cookie by name
    getCookiebyName: function(name) {
        var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
        return !!pair ? pair[1] : null;
    },
    cookieFalse: function(){
        Cookies.set(ACC.lovelistCookieName, 'false');
    },
    // if the `customerName` cookie is present, toggle the corresponding header items
    handleCustomerInfo: function() {
        var cookieValue = ACC.common.getCookiebyName('customerName');
        var $headerLinks = $('[data-header-links]');

        if ($headerLinks.length > 0) {
            var $signedOutListItem =  $headerLinks.find('[data-signed-out]');
            var $signedInListItem =  $headerLinks.find('[data-signed-in]');
            var $myAccountListItem = $headerLinks.find('[data-my-account]');
            var $customerNameNode = $headerLinks.find('[data-user-name]');

            if (cookieValue) {
                var decodedCookieValue = decodeURIComponent(cookieValue);
                $signedOutListItem.attr('hidden');
                $signedInListItem.removeAttr('hidden');
                $signedInListItem.css('display', 'inline-block');
                $myAccountListItem.removeAttr('hidden');
                // truncate user name to 25 characters
                $customerNameNode.text(' ' + decodedCookieValue.substring(0, 25));
            } else {
                if ($signedOutListItem.attr('hidden')) {
                    $signedOutListItem.removeAttr('hidden');
                    $signedOutListItem.css('display', 'inline-block');
                }
            }
        }
    },
    removeFromLocalStorage: function (item) {
        try {
            localStorage.removeItem(item);
        } catch (e) {
            return;
        }
    },
    storeInLocalStorage: function (itemTitle, itemValue) {
        try {
            if (itemValue) {
                localStorage.setItem(itemTitle, JSON.stringify(itemValue));
                ACC.vueMiniCart?.updateMiniCartDisplay(true);
            }
        } catch (e) {
            console.log('Error when writing to localStorage \n' + e);
        }
    },
    getFromLocalStorage: function (itemTitle) {
        try {
            if (itemTitle) {
                var parsedData = JSON.parse(localStorage.getItem(itemTitle));
                return parsedData;
            }
        } catch (e) {
            console.log('Error when reading from localStorage \n' + e);
        }
    },

    deleteCookie: function(name){
		document.cookie = `${name}=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	},

    bindLogoutActions: function() {
        $(".header-logout-text").on("click", function() {
            ACC.checkoutsteps.clearSelectedStore();
            
        });
    },
    ajaxSolrCarousel:function(compId){
        $.ajax({
            url: ACC.config.encodedContextPath + "/view/TjxSolrQueryProductCarouselComponentController/productData",
            type: "GET",
            data: {
                componentUid : compId,
                product:$('input[name="productCodePost"]').val(),
                gtmPageType:ACC.gtm.pageType,
                gtmPageName:ACC.gtm.pageName,
                gtmPageUrl:ACC.gtm.pageUrl
            },
            success: function(data) {
                $('#solrCarousel-' + compId + ' .product-carousel-wrapper').html(data);
                if (typeof window.reloadVueComponent === "function") {
                    window.reloadVueComponent($('#solrCarousel-' + compId + ' [data-app]')[0]);
                }
            }
        });
    },
    initSolrCarousel:function(compId){
        var setuppc = $('.product-multi-4');
        if(setuppc.length > 0){
            ACC.carousel.setupProductCarousel(compId);
        }
    },
    resizeTeaserImg: function() {
        var teaser = $('.teaser-wrapper');
        if (teaser.length > 0) {
            if ($(window).width() > 768) {
                // only for desktop and tablet landscape
                teaser.each(function(index) {
                    var textBox = $(this).find('.media-text');
                    var textBoxHeight = textBox.height();
                    var imgHeight = textBoxHeight + 120;
                    var videoIcoX = Math.round(imgHeight/2);

                    $(this).find('.media-container').css({
                        'min-height': imgHeight
                    });

                    $(this).find('.icon.icon-play-circle').css({
                        'top': videoIcoX
                    });
                });

                const isWideContainer = teaser.find('.wide-container').length > 0;
                let mediaItemWidth = '470';
                if ( isWideContainer && $(window).width() > 1200 ) {
                    mediaItemWidth = '100%';
                }
                $('.teaser-wrapper .media-item').css({
                    'width': mediaItemWidth
                });

            } else {
                // remove styles
                $('.media-container').css({
                    'height': ''
                });

                $('.media-container .icon.icon-play-circle').css({
                    'top': ''
                });
                $('.teaser-wrapper .media-item').css({
                    'width': ''
                });
            }
        }
    },
    flashEventBox: function() {
        var $flashBox = $('#FlashEventsHeroBannerComponent');
        var $imgFlash = $('#img-flash');
        var checkPage = $flashBox.length;
        var windowSize = $(window).width();
        var finalHeight;
        var imgUrl;

        if (checkPage > 0) {
            var heightTextBox = $('.flash-events-banner-text').height();
            if (windowSize < 769 && windowSize > 641) {
                finalHeight = heightTextBox + 360 + 20;
                imgUrl = $imgFlash.data('tablet');
                $flashBox.css({'height': finalHeight});
            } else if (windowSize < 640) {
                finalHeight = heightTextBox + 320 + 15;
                imgUrl = $imgFlash.data('mobile');
                $flashBox.css({'height': finalHeight});
            } else {
                imgUrl = $imgFlash.data('desktop');
                $flashBox.removeAttr('style');
            }
            $imgFlash.css({'background-image': 'url('+imgUrl+')'});
        }
    },

    getVariant: function () {
        // The size selector buttons are radio buttons
        // so we just check for the `checked` one inside variant-selector div
        var $selectedVariant = $("input:checked", ".js-variant-selector");
        var inputId = $selectedVariant.attr('id');
        var variant = $("label.variantlabel[for='"+inputId+"']").text();
        if (variant.length === 0) {
            variant = 'nosize';
        }
        return variant;
    },
    checkLoveListModal: function () {
        var showLoveListModal = false;
        var limitCheckModalVar = document.getElementById('loveListPopup').value;
        var loveListKey = ACC.lovelistKey;
        var currentLoveList = ACC.common.getLocalStorageParsedItem(loveListKey);
        var currentLoveListProductCount = 0;
        if (Array.isArray(currentLoveList?.loveListProductInfo)) {
            currentLoveListProductCount = currentLoveList.loveListProductInfo.length;
        }
        if (currentLoveListProductCount > 0 && currentLoveListProductCount.toString() === limitCheckModalVar) {
            showLoveListModal = true;
        }
        return showLoveListModal;
    },

    loveListModal: function () {
        $('#lovelist-modal-signIn').modal('show');
        $('#lovelist-modal-signIn').on('hidden.bs.modal', function (e) {
            var modalPositionHeight = $('.c-refine').height() + $('.main-header').height();
            $('.add-focus').focus();
            $('html, body').animate({
                scrollTop: (($('.add-focus').offset().top)- modalPositionHeight)
            },500, function() {
                $('.love-button').removeClass('add-focus');
            });
        });
    },
    enableHeaderLoveListIcon: function () {
        var loveListKey = ACC.lovelistKey;
        var currentLoveList = ACC.common.getLocalStorageParsedItem(loveListKey);
        var currentLoveListProductCount = 0;
        if (Array.isArray(currentLoveList?.loveListProductInfo)) {
            currentLoveListProductCount = currentLoveList.loveListProductInfo.length;
        }
        if (currentLoveListProductCount > 0) {
            $('.header-lovelist-link').find('.icon-heart-header').addClass('icon-heart-outline-header');
        } else {
            $('.header-lovelist-link').find('.icon-heart-header').removeClass('icon-heart-outline-header');
        }
    },
    compareLoveListExpiry: function (date) {
        var guestExpirationDay = parseInt($('#guestExpirationDay').val());
        var compareLoveListExpiry = false;
        var userLoveListDateAdded = date;
        var currentDate = new Date();
        var currentDateTimeStamp = currentDate.getTime();

        var dateArray = userLoveListDateAdded.split(' ');
        var dateValue = dateArray[0];
        var timeValue = dateArray[1];
        var dateValueArray = dateValue.split('-');
        var year = parseInt(dateValueArray[0]);
        var month = parseInt(dateValueArray[1])-1;
        var day = parseInt(dateValueArray[2]);

        var timeValueArray = timeValue.split(':');

        var hour = parseInt(timeValueArray[0]);
        var minutes = parseInt(timeValueArray[1]);
        var seconds = parseInt(timeValueArray[2]);
        var miliseconds = parseInt(timeValueArray[3]);

        var lsExpiryDate = new Date(year, month, day+guestExpirationDay, hour, minutes, seconds, miliseconds);
        var lsExpiryDateTimestamp = lsExpiryDate.getTime();
        if (currentDateTimeStamp > lsExpiryDateTimestamp) {
            compareLoveListExpiry = true;
        }
        return compareLoveListExpiry;
    },

    checkLoveListExpiry: function () {
        if (ACC.gtm.isEmpty(ACC.gtm.getCookiebyName(ACC.lovelistCookieKey))) {
            var userLoveListObj = ACC.common.getLocalStorageParsedItem(ACC.lovelistKey);
            if (userLoveListObj && !ACC.gtm.isEmpty(userLoveListObj.dateAdded)) {
                var userLoveListDateAdded = ACC.common.compareLoveListExpiry(userLoveListObj.dateAdded);
                if (userLoveListDateAdded) {
                    window.localStorage.removeItem(ACC.lovelistKey);
                    ACC.common.enableHeaderLoveListIcon();
                    $('.icon-heart').removeClass('icon-heart').addClass('icon-heart-empty');
                    $('.lovelist-page').hide();
                    $('.show-empty-container').addClass('show-empty');
                }
            }
        }
    },

    loveAnimation: function () {
        $('.just-in .icon-heart').mouseover(function () {
            $(this).removeClass('pulse-animate');
        });
    },

    removeProductInLoveList: function () {
        var orderedProduct = document.getElementById("orderedproduct");
        if (orderedProduct && orderedProduct.value !== '[]') {
            var orderedProductValue = orderedProduct.value;
            orderedProductValue = orderedProductValue.replace(/^\[(.+)\]$/, '$1');
            var productLists = orderedProductValue.split(',');
            if (Array.isArray(productLists)) {
                for (var i = 0; i < productLists.length; i++) {
                    var currentProductCode = productLists[i].trim();
                    var loveListKey = ACC.lovelistKey;
                    var currentLoveList = ACC.common.getLocalStorageParsedItem(loveListKey);
                    if (Array.isArray(currentLoveList?.loveListProductInfo)) {
                        var currentProductItems = currentLoveList.loveListProductInfo;
                        var foundInArray = false;
                        for (var index = 0; index < currentProductItems.length;) {
                            var productCodeStr = currentProductItems[index].productCode.toString();
                            if (productCodeStr === currentProductCode.toString()) {
                                currentProductItems.splice(index, 1);
                                foundInArray = true;
                                break;
                            }
                            index++;
                        }
                        if (foundInArray) {
                            var today = new Date();
                            var date = today.getFullYear()+'-'+(today.getMonth() + 1)+'-'+today.getDate();
                            var time = today.getHours()+':'+today.getMinutes()+':'+today.getSeconds()+':'+today.getMilliseconds();
                            var dateTime = date+' '+time;

                            currentProductItemObj.loveListProductInfo = currentProductItems;
                            currentProductItemObj.dateAdded = dateTime.toString();
                            window.localStorage.setItem(loveListKey, JSON.stringify(currentProductItemObj));
                        }
                    }
                }
            }
        }
    },
    updateTooltip: function (data) {
        var allToolTipElement = document.querySelectorAll('.'+data);
        for (var i = 0; i < allToolTipElement.length; i += 1) {
            allToolTipElement[i].classList.remove(data);
        }
    },
    syncLoveList: function() {
        return new Promise(function(resolve, reject) {
            var llCookieValue = ACC.common.getCookiebyName(ACC.lovelistCookieName);
            if (llCookieValue === 'true') {
                var url = ACC.lovelistDataUrl;
                $.ajax({
                    url: url,
                    type: 'get',
                    cache: false,
                    success: function (data) {
                        resolve(data);
                    },
                    error: function(error) {
                        reject(false);
                    }
                });
            } else {
                resolve('');
            }
        });
    },
    updateLovelist: function(data) {
        if(!ACC.gtm.isEmpty(data)) {
            try {
                var lovelistData = JSON.parse(data);
                if (lovelistData.hasOwnProperty('dateAdded') && lovelistData.hasOwnProperty('loveListProductInfo')) {
                    localStorage.setItem(ACC.lovelistKey, data);
                    ACC.common.cookieFalse();
                    ACC.common.enableHeaderLoveListIcon();
                }
            } catch (e) {
                console.error('Error parsing lovelist data:', e);
            }
        }
    },
    onLoadUpdateLoveList: function() {
        var promise = ACC.common.syncLoveList();
        promise.then(function (response) {
            ACC.common.updateLovelist(response);
        }).catch(()=> {
            console.error('Error fetching lovelist data.');
        });
    },
    handleGAEvents: function () {
        const cookieValue = ACC.common.getCookiebyName('GA_GLOBAL_EVENTS');
        
            if (cookieValue) {
                // Split the cookie value by the pipe character to get an array of events
                const events = cookieValue.split('|');
        
                // Iterate over each event and make an AJAX call
                events.forEach((eventName) => {
                    $.ajax({
                        url: `${ACC.config.encodedContextPath}/gtm/getSessionGtmEventData/${eventName}`,
                        data: "",
                        async: true,
                        dataType: "html"
                    })
                        .done(function (data) {
                            try {
                                const parsedData = JSON.parse(data);
                                ACC.gtmToGa.pushGaGlobalContainer(parsedData);
                            } catch (error) {
                                console.error(`Failed to parse event data for event: ${eventName}`, error);
                            }
                        })
                        .fail(function (error) {
                            console.error(`Failed to fetch event data for event: ${eventName}`, error);
                        });
                });
        
                // Delete the cookie after processing all events
                ACC.common.deleteCookie('GA_GLOBAL_EVENTS');
            }
    },

    // The getItemDetails() function determines the current page context (e.g., Search, Category, Product, Lovelist, or Carousels)
    // and returns an object with `itemName` and `itemPageId`, assigning the appropriate values based on the page type
    // and relevant details such as search terms, product detail, or carousel IDs for GA4 tracking purposes.
    getItemDetails: function() {
        const pageType = window.ACC.gtm?.gtmGlobal?.pageType;
        const pageName = window.ACC.gtm?.gtmGlobal?.pageName;
        const isPlp = document.body?.className.match('template-pages-category-productGridPage');
        const externalCarousels = document.querySelectorAll('.js-product-carousel');

        let itemName = null;
        let itemPageId = null;

        if (pageType === 'Search') {
            itemPageId = '10000002';
            itemName = 'Search Results';
        } else if (pageType === 'CategoryPage' && isPlp) {
            itemPageId = pageName.split('|').pop() || null;
            itemName = 'Product Listing';
        } else if (pageType === 'ProductPage') {
            itemName = 'Product detail page';
            itemPageId = pageName.split('|').pop() || null;
        } else if (pageType === 'LoveListPage') {
            itemName = 'Lovelist';
            itemPageId = '10000001';
        }

        return { itemName, itemPageId };
    },

    toggleBannerClass: function() {
        var ps = document.getElementById('js-banner-text');

        if (ps) {
            if (ps.offsetHeight !== ps.scrollHeight) {
                ps.classList['remove']('truncated');
            }

            if (!ps.classList.contains('truncated')) {
                var heroBannerContainer = document.getElementsByClassName('hero-responsive-banner-background')[0];
                var bannerContainer = document.getElementsByClassName('simple-responsive-banner-component')[0];
                var readMoreBtn = $('.banner-read-more-btn');
                const readLessText = readMoreBtn.data('collapse');
                if (heroBannerContainer && bannerContainer) {
                    readMoreBtn.text(readLessText);

                    if($('#js-banner-text').is(':hidden')) {
                        readMoreBtn.hide();
                    } else {
                        readMoreBtn.show();
                    }

                    heroBannerContainer.classList.add('maxHeight');
                    bannerContainer.classList.add('maxHeight');

                    if (ACC.common.isBannerExpanded && Math.round(ps.scrollHeight / 10) * 10 <= 40) {
                        heroBannerContainer.classList.remove('maxHeight');
                        bannerContainer.classList.remove('maxHeight');
                    }
                }
            }
        }
    },
    toggleReadMore: function() {
        var ps = document.getElementById('js-banner-text');

        if (ps) {
            if (!ACC.common.isBannerExpanded) {
                /* The initial state of the Read More button(.banner-read-more-btn) is display: none;
                Based on the 20px line height of the text, the Read More button is displayed only if the banner text has more than 2 lines.
                The 20px line-height is set on:
                    - the .banner-text element that contains the text
                or
                    - the nested element of .banner-text(for the case when the SE field includes an HTML tag)
                */
                var textHeight =  Math.round(ps.scrollHeight / 10) * 10 <= 40;
                ps.classList[textHeight ? 'remove' : 'add']('truncated');
                var readMoreBtn = $('.banner-read-more-btn');
                if (ps.classList.contains('truncated')) {
                    readMoreBtn.css('display', 'inline-block');
                } else {
                    readMoreBtn.css('display', 'none');
                }
            } else {
                ACC.common.toggleBannerClass();
            }
        }
    },

    tempDisable: function(elem, clickEvent) {
        if ($(elem).hasClass("active")) {
            $(elem).removeClass("active");
            setTimeout(
                function() {$(elem).addClass("active");},
                3000);
        }
        else {
            clickEvent.preventDefault();
        }
    },

    addTempDisable: function(elem, elementType) {
        $(elem).addClass("active");
        if (elementType == "a") {
            $(elem).click(function (clickEvent) {
                ACC.common.tempDisable(elem, clickEvent);
            });
        } else {
            var parent = $(elem).parent();
            parent.on("click", elem, function (clickEvent) {
                ACC.common.tempDisable(elem, clickEvent);
            });
        }
    },

    createProcessingSpinner: function() {
        if ($('body .processing-spinner').length) return;
        var $spinnerDiv = $("<div class='processing-spinner'></div>").hide();
        $('body').append($spinnerDiv);
    },

    showProcessingSpinner: function() {
        ACC.common.createProcessingSpinner();
        $('html').css('top', - (document.documentElement.scrollTop) + 'px').addClass('disable-scroll');
        $('body .processing-spinner').show();
    },

    hideProcessingSpinner: function() {
        $('html').removeClass('disable-scroll');
        document.documentElement.scrollTop = - parseInt($('html').css('top'));
        $('html').css('top', '')
        $('body .processing-spinner').hide();
    },

    getCSRFTokenJS: function(){
        var url= `${ACC.config.encodedContextPath}/ajax/getCSRFToken`;
        var token= '';
		$.ajax({
			url: url,
			type: "get",
            async: false,
            dataType: 'json',
			success: function (response){
				token = response;
			},
			error: function (xhr) {
                return "";
			}
		});
        return token;
	},

    chooseResizeVal: function(desktop, tablet, mobile) {
        const width = $(window).width()
        if (width >= 1024) {
            return desktop;
        }
        else if (width >= 641 && width < 1023) {
            return tablet;
        }
        else if (width <= 640) {
            return mobile;
        }
    },

    sendToMobileApp: function(messageContent) {
        // Check if in mobile app context
		const isMobileApp = typeof TKMaxxWebView !== 'undefined';

		if (isMobileApp) {
			// Send the message to the mobile app
			TKMaxxWebView.postMessage(JSON.stringify(messageContent));
		}
	},

    getLocalStorageParsedItem: function (key) {
        var parsedData = null;
        if (key && localStorage.getItem(key)) {
            try {
                parsedData = JSON.parse(localStorage.getItem(key));
            }
            catch {
                localStorage.removeItem(key);
                console.error(`Error parsing ${key} data from localStorage, removing corrupted data.`);
            }
        }
        return parsedData;
    },

    // Add class for specific usecase where styling is specifc or different for IOS devices
    addDeviceClasses: function () {
        // Detect iPhone
        const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
    
        // Detect Mac
        const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.userAgent);
    
        // Detect iPad or iOS tablets
        const isTablet = /iPad|Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;

        // Add classes to body tag
        if (iPhone) {
            document.body.classList.add('iphone');
        } else if (isTablet) {
            document.body.classList.add('ios-tablet');
        } else if (isMac) {
            document.body.classList.add('mac');
        }
    },

};





/* Extend jquery with a postJSON method */
jQuery.extend({
    postJSON: function (url, data, callback)
    {
        return jQuery.post(url, data, callback, "json");
    }
});

// add a CSRF request token to POST ajax request if its not available
$.ajaxPrefilter(function (options, originalOptions, jqXHR)
{
    // Modify options, control originalOptions, store jqXHR, etc
    if (options.type === "post" || options.type === "POST")
    {
        var noData = (typeof options.data === "undefined");
        if (noData || options.data.indexOf("CSRFToken") === -1)
        {
            ACC.config.CSRFToken = ACC.common.getCSRFTokenJS();
            const csrfToken = ACC.config.CSRFToken;
            options.data = (!noData ? options.data + "&" : "") + "CSRFToken=" + csrfToken;
        }
    }
});

$(window).on('load', function() {
    if ($("#claimRewardSubmit").length > 0) {
        ACC.common.addTempDisable("#claimRewardSubmit", "button");
    }
})

$(document).ready(function () {
    if ($("#miniCart a").length > 0) {
        ACC.common.addTempDisable("#miniCart a", "a");
    }
    ACC.common.addDeviceClasses();
    ACC.common.onLoadUpdateLoveList();
    ACC.common.loveAnimation();
    ACC.common.checkLoveListExpiry();
    const cookieValue = ACC.common.getCookiebyName('GA_GLOBAL_EVENTS');
    if (cookieValue) {
    ACC.common.handleGAEvents();
    }

    var solrCarousels = $('.product-carousel-wrapper');
    if (solrCarousels.length > 0) {
        $(solrCarousels).each(function() {
            var solrCarouselId = $(this).data("solrCarouselId");
            ACC.common.ajaxSolrCarousel(solrCarouselId);
        })
    }

    if ($(".checkout-header").length == 0) {
        ACC.common.handleCustomerInfo();
        ACC.common.bindLogoutActions();
        ACC.common.productCheck();
        ACC.common.resizeTeaserImg();
    }
    ACC.common.flashEventBox();
    ACC.common.removeProductInLoveList();
    ACC.common.enableHeaderLoveListIcon();
    ACC.common.toggleReadMore();
});

$(window).resize(function () {
    ACC.common.resizeTeaserImg();
    ACC.common.flashEventBox();
    ACC.common.toggleReadMore();
});

(function() {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();

// Bind Read More banner link click event.
(function () {
    $(document).on('click', '.banner-read-more-btn', function() {
        const readMoreBtn = $('.banner-read-more-btn');
        const readMoreText = readMoreBtn.data('expand');
        if (ACC.common.isBannerExpanded) {
            ACC.common.isBannerExpanded = false;
            $('.banner-text').addClass('truncated');
            $(this).text(readMoreText);
            $(this).attr('aria-expanded', 'false');
        } else {
            $('.banner-text').removeClass('truncated');
            ACC.common.toggleBannerClass();
            ACC.common.isBannerExpanded = true;
            $(this).attr('aria-expanded', 'true');
        }
    });
})();

var allScriptsLoaded = new CustomEvent('allScriptsLoaded');
window.dispatchEvent(allScriptsLoaded);
